import './customInputAnnualLeave.scss';

interface ICustomInputAnnualLeave {
    title: string;
    placeHolder: string;
}

const customInputAnnualLeave = ({ title, placeHolder }: ICustomInputAnnualLeave) => {
    return (
        <div className="customInputAnnualLeave">
            <div className="title">{title}</div>

            <div className="containerArea">
                <input type="text" placeholder={placeHolder} />

                <div className="unit">일</div>
            </div>
        </div>
    );
};

export default customInputAnnualLeave;
